import useDropdown from './useDropdown';

export function DropdownTrigger({ className, children }) {
    const {
        triggerRef,
        settings,
        show,
        hide
    } = useDropdown();
    const { hasMouseMoveEvents } = settings;
    const conditionalProps = {};

    if (hasMouseMoveEvents) {
        conditionalProps.onMouseEnter = show;

        conditionalProps.onMouseLeave = (event) => {
            hide(event, true);
        };
    }

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div
            ref={triggerRef}
            className={className}
            onClick={show}
            {...conditionalProps}
        >
            {children}
        </div>
    );
}
